import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const changeCloseDateFormDialogStyle: StyleRulesCallback = () => {
  return {
    paperWidthMd: {
      width: '500px',
    },
  };
};

export default changeCloseDateFormDialogStyle;
